var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-item"},[_c('span',{staticClass:"dropdown-label-box color-item-color",style:({ backgroundColor: _vm.color }),attrs:{"data-testid":"color-item"}}),_vm._v(" "),_c('span',{staticClass:"color-item-text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }